import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ChannelWorkflowMappingService {

  private baseUrl = `${environment.apiBaseUrl}/api/channel-workflow-mappings`;

  constructor(private api: ApiService) {}

  getChannelsWithWorkflows() {
    return this.api.get('/api/channel-workflow-mappings/channels');
  }

  createMappings(payload: any) {
    return this.api.post('/api/channel-workflow-mappings', payload);
  }

  deleteMapping(id: string) {
    return this.api.delete(`/api/channel-workflow-mappings/${id}`);
  }

  // =========================
  // WORKFLOWS (ADD MAPPING MODAL)
  // =========================

  /** GET /api/channel-workflow-mappings/workflows */
 getActiveWorkflows(): Observable<any[]> {
  return this.api.get<any[]>('/api/channel-workflow-mappings/workflows');
}

 getAllWorkflows(): Observable<any[]> {
  return this.api.get<any[]>('/api/channel-workflow-mappings/workflows');
}
}
